import React from 'react';

function FormHeading({ title, labelStyle }) {
    return (
        <div className="formHeadingTag">
            <h2 className="titleForm" style={labelStyle}>{title}</h2>
        </div>
    );
}

export default FormHeading;